import React, { createContext, useContext, useState, useEffect } from "react";
import ReactPixel from "react-facebook-pixel";
import useHistoryParams from "./useHistoryParam";
import { initTikTokPixel } from "./tiktokPixel";

// Create the PromoContext
const PromoContext = createContext();

// Custom hook to use PromoContext
export const usePromo = () => useContext(PromoContext);

// PromoProvider component
export const PromoProvider = ({ children }) => {
  const { params, updateParams } = useHistoryParams();
  const [promo, setPromo] = useState(0.5);

  useEffect(() => {
    let pixelParam = params.get("p"); // Retrieve 'p' parameter
    if (pixelParam) pixelParam = pixelParam.replace(/\D/g, '');
    
    // Retrieve TikTok 'tt' parameter
    let ttParam = params.get("tt");
    if (!ttParam && window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      ttParam = searchParams.get("tt");
    }

    const promoAmount = params.get("promo"); // Retrieve 'promo' parameter
    const clickParam = params.get("click_id");

    if (clickParam) {
      localStorage.setItem("clickParam", clickParam);
    }

    // Initialize Facebook Pixel if pixelParam exists, else use localStorage
    if (pixelParam && pixelParam.length > 0) {
      localStorage.setItem('pixel_p', pixelParam);
      ReactPixel.init(pixelParam);
      console.log("Facebook Pixel initialized with:", pixelParam);
    } else {
      let cachedP = localStorage.getItem('pixel_p');
      if (cachedP) cachedP = cachedP.replace(/\D/g, '');
      if (cachedP && cachedP.length > 0) {
        ReactPixel.init(cachedP);
        console.log("Facebook Pixel initialized with cached:", cachedP);
      }
    }

    // Initialize TikTok Pixel if ttParam exists, else use cached
    if (ttParam) {
      localStorage.setItem('pixel_tt', ttParam);
      initTikTokPixel(ttParam);
      console.log("TikTok Pixel initialized with:", ttParam);
    } else {
      const cachedTT = localStorage.getItem('pixel_tt');
      if (cachedTT) {
        initTikTokPixel(cachedTT);
        console.log("TikTok Pixel initialized with cached:", cachedTT);
      }
    }

    // Update state with promo details if promoAmount exists
    if (promoAmount) {
      setPromo((100 - promoAmount) / 100);
      console.log("Promo amount set to:", (100 - promoAmount) / 100);
    }

    // Clean params if needed
    if (pixelParam || promoAmount || clickParam) {
      updateParams({ p: null, promo: null, click_id: null });
    }
  }, [params, updateParams]);

  return (
    <PromoContext.Provider value={promo}>{children}</PromoContext.Provider>
  );
};
